// extracted by mini-css-extract-plugin
module.exports = {"personSelect":"PersonSelect_personSelect__31-_R","label":"PersonSelect_label__2_x_o","option":"PersonSelect_option__31uSz","radio":"PersonSelect_radio__2iKHC"};